<div class="coach-mark" [class]="'coach-mark--tone-' + tip.tone" data-testid="ftue-coach-mark">

  <!-- ── Header: tone chip + dismiss ──────────────────────────────────────── -->
  <div class="coach-mark__header">
    <span class="coach-mark__chip">
      <ui-icon [name]="toneIcon" size="small"></ui-icon>
      <span>{{ i18n.label | translate }}</span>
    </span>
    <button
      type="button"
      class="coach-mark__close"
      [attr.aria-label]="'ftue.card.dismiss' | translate"
      (click)="dismissed.emit('close')">
      <ui-icon name="X" size="medium"></ui-icon>
    </button>
  </div>

  <!-- ── Body ─────────────────────────────────────────────────────────────── -->
  <h3 class="coach-mark__title">{{ i18n.title | translate }}</h3>
  <p class="coach-mark__body">{{ i18n.body | translate }}</p>

  <!--
    The promise the framework actually keeps. With no scrim to signal "one-off",
    this line and the quiet settings link below are what stop a tip from reading
    like a notification that will come back.
  -->
  <p class="coach-mark__note">
    {{ (isPreview ? 'ftue.card.preview_note' : 'ftue.card.once_note') | translate }}
  </p>

  <!-- ── Footer ───────────────────────────────────────────────────────────── -->
  <div class="coach-mark__footer">
    <!--
      Sends the user to Settings → Product tips rather than switching tips off in
      one click: the same place also holds the reset and the inventory, and an
      irreversible-feeling "off" does not belong on a first encounter.
    -->
    <button
      *ngIf="!isPreview"
      type="button"
      class="coach-mark__settings-link"
      (click)="settingsRequested.emit()">
      {{ 'ftue.card.tips_settings' | translate }}
    </button>
    <ui-button
      type="primary"
      [label]="'ftue.card.got_it' | translate"
      (click)="dismissed.emit('action')">
    </ui-button>
  </div>
</div>
